document.addEventListener('DOMContentLoaded', () => {

  const ambassadorSections = document.querySelectorAll('.wg-ambassadors');

  ambassadorSections.forEach(section => {

    const viewport = section.querySelector('.wg-ambassadors__viewport');
    const track = section.querySelector('.wg-ambassadors__track');

    if (!viewport || !track) return;

    /* ==========================================
       MOBILE
    ========================================== */

    if (window.innerWidth <= 767) {

      viewport.style.overflowX = 'auto';

      return;

    }

    /* ==========================================
       ACCESSIBILITY
    ========================================== */

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {

      return;

    }

    /* ==========================================
       DUPLICATE FOR TRUE INFINITE LOOP
    ========================================== */

    if (!track.dataset.cloned) {

      [...track.children].forEach(card => {

        track.appendChild(card.cloneNode(true));

      });

      track.dataset.cloned = "true";

    }

    /* ==========================================
       CONTINUOUS SCROLL
    ========================================== */

    let x = 0;

    let paused = false;

    const speed = 0.45;

    function animate(){

      if(!paused){

        x -= speed;

        if(Math.abs(x) >= track.scrollWidth / 2){

          x = 0;

        }

        track.style.transform = `translate3d(${x}px,0,0)`;

      }

      requestAnimationFrame(animate);

    }

    animate();

    /* ==========================================
       PAUSE
    ========================================== */

    viewport.addEventListener('mouseenter', () => {

      paused = true;

    });

    viewport.addEventListener('mouseleave', () => {

      paused = false;

    });

  });

});